var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50391 9.6969C7.08273 10.8922 8.04929 11.8563 9.24609 12.4321C9.33437 12.4739 9.43202 12.4919 9.52942 12.4845C9.62681 12.4772 9.72061 12.4445 9.80156 12.3899L11.5594 11.2156C11.637 11.163 11.7268 11.1308 11.8202 11.1222C11.9137 11.1136 12.0078 11.1288 12.0937 11.1664L15.3844 12.5797C15.4968 12.6265 15.5908 12.709 15.6518 12.8145C15.7128 12.9199 15.7374 13.0425 15.7219 13.1633C15.6176 13.9773 15.2202 14.7255 14.6042 15.2677C13.9882 15.81 13.1957 16.1092 12.375 16.1094C9.83887 16.1094 7.40661 15.1019 5.61329 13.3086C3.81997 11.5153 2.8125 9.08303 2.8125 6.5469C2.81268 5.72621 3.1119 4.9337 3.65416 4.31768C4.19642 3.70165 4.94456 3.30432 5.75859 3.20002C5.87942 3.1845 6.00199 3.20913 6.10745 3.27012C6.2129 3.3311 6.29538 3.42506 6.34219 3.53752L7.75547 6.83518C7.79222 6.9198 7.8076 7.01216 7.80024 7.10412C7.79288 7.19608 7.76302 7.28482 7.71328 7.36252L6.53906 9.14846C6.48679 9.22924 6.4561 9.32207 6.44995 9.41809C6.44379 9.51411 6.46237 9.61011 6.50391 9.6969V9.6969Z",
    stroke: "white",
    strokeWidth: 1.1084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5a9f53de3b4cec1ce7f5037277c37af7.svg";
export { ForwardRef as ReactComponent };